import React, { useState } from 'react';
import { MatchPeople } from './MatchPeople';
import { MatchConnections } from './MatchConnections';
import { Filter, X } from 'lucide-react';
interface Props {
  onScanPress: () => void;
}
const AVAILABLE_THEMES = ['AI Governance', 'Climate Finance', 'Supply Chain', 'Water Security', 'Clean Energy', 'Impact Investing'];
export function MatchContainer({
  onScanPress
}: Props) {
  const [view, setView] = useState<'people' | 'connections'>('people');
  const [selectedThemes, setSelectedThemes] = useState<string[]>([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const toggleTheme = (theme: string) => {
    setSelectedThemes(prev => prev.includes(theme) ? prev.filter(t => t !== theme) : [...prev, theme]);
  };
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] overflow-hidden relative" data-id="element-208">
      {/* Fixed Header */}
      <div className="bg-[#0D0D0D] border-b border-[#2A2A2A]/50 px-6 pt-10 pb-4 flex items-center justify-between gap-3 flex-shrink-0" data-id="element-209">
        {/* Segmented Toggle */}
        <div className="flex bg-[#141414] rounded-full p-1 flex-1 min-w-0" data-id="element-210">
          <button onClick={() => setView('people')} className={`flex-1 py-2 rounded-full text-[13px] font-medium transition-all duration-200 text-center ${view === 'people' ? 'bg-[#C5D82D] text-[#0D0D0D]' : 'bg-transparent text-[#888888]'}`} data-id="element-211">
            Scopri
          </button>
          <button onClick={() => setView('connections')} className={`flex-1 py-2 rounded-full text-[13px] font-medium transition-all duration-200 text-center ${view === 'connections' ? 'bg-[#C5D82D] text-[#0D0D0D]' : 'bg-transparent text-[#888888]'}`} data-id="element-212">
            Connessi (2)
          </button>
        </div>

        {/* Filter Button — always visible for layout consistency */}
        <button onClick={() => setIsFilterOpen(true)} className={`w-9 h-9 rounded-full border flex items-center justify-center active:scale-95 transition-all duration-200 flex-shrink-0 relative ${selectedThemes.length > 0 ? 'border-[#C5D82D] text-[#C5D82D]' : 'border-[#2A2A2A] text-white'}`} data-id="element-213">
          <Filter className="w-4 h-4" strokeWidth={2.5} data-id="element-214" />
          {selectedThemes.length > 0 && <div className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-[#C5D82D] flex items-center justify-center" data-id="element-215">
              <span className="text-[9px] font-bold text-[#0D0D0D]" data-id="element-216">
                {selectedThemes.length}
              </span>
            </div>}
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-hidden min-h-0" data-id="element-217">
        {view === 'people' && <MatchPeople selectedThemes={selectedThemes} onViewConnections={() => setView('connections')} data-id="element-218" />}
        {view === 'connections' && <MatchConnections data-id="element-219" />}
      </div>

      {/* Theme Filter Modal */}
      {isFilterOpen && <div className="absolute inset-0 z-50 flex flex-col justify-end" data-id="element-220">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200" onClick={() => setIsFilterOpen(false)} data-id="element-221" />

          {/* Bottom Sheet */}
          <div className="relative bg-[#141414] border-t border-[#2A2A2A] rounded-t-2xl pt-6 pb-8 px-6 animate-in slide-in-from-bottom-full duration-300" data-id="element-222">
            <div className="flex items-center justify-between mb-6" data-id="element-223">
              <h2 className="text-[18px] font-medium text-white tracking-tight" data-id="element-224">
                Filtra per tema
              </h2>
              <button onClick={() => setIsFilterOpen(false)} className="w-8 h-8 rounded-full bg-[#1A1A1A] flex items-center justify-center text-[#888888] active:scale-95" data-id="element-225">
                <X className="w-4 h-4" data-id="element-226" />
              </button>
            </div>

            <div className="flex flex-wrap gap-2.5 mb-8" data-id="element-227">
              {AVAILABLE_THEMES.map(theme => {
            const isSelected = selectedThemes.includes(theme);
            return <button key={theme} onClick={() => toggleTheme(theme)} className={`
                      px-4 py-2 rounded-full text-[13px] font-medium transition-all duration-200 border
                      ${isSelected ? 'bg-[#C5D82D] border-[#C5D82D] text-[#0D0D0D]' : 'bg-transparent border-[#2A2A2A] text-white hover:border-[#555555]'}
                    `} data-id="element-228">
                    {theme}
                  </button>;
          })}
            </div>

            <div className="flex gap-3" data-id="element-229">
              <button onClick={() => setSelectedThemes([])} className="flex-1 py-3.5 rounded-full border border-[#2A2A2A] text-white text-[14px] font-medium active:scale-95 transition-all" data-id="element-230">
                Mostra tutti
              </button>
              <button onClick={() => setIsFilterOpen(false)} className="flex-1 py-3.5 rounded-full bg-[#C5D82D] text-[#0D0D0D] text-[14px] font-medium active:scale-95 transition-all" data-id="element-231">
                Applica
              </button>
            </div>
          </div>
        </div>}
    </div>;
}